import { FeatureToggleService as service } from '@ply-io/ply-front-shared-utilities';

const LD_CLIENT_SIDE_ID = process.env.VUE_APP_LD_CLIENT_SIDE_ID;

/**
 * Using FeatureToggleService implemented in PlyFrontSharedUtilities
 * Read https://github.com/ply-io/ply-front-shared-utilities/blob/main/src/services/feature-toggle-service/README.md to understand how to use it
 */

service.setClientSideId(LD_CLIENT_SIDE_ID); // init env client side id

const applyFn =
	(fn) =>
	(...args) => {
		try {
			return fn(...args);
		} catch (err) {
			console.log('FeatureToggleService args:', args);
			console.error(err);
			return null;
		}
	};

export const FEATURE_FLAGS = Object.freeze({
	SHOW_ACTION_PARAM_METADATA: 'show-action-param-metadata',
	SHOW_CLOUD_FLOWS_CREATION: 'allow-cloud-flows-creation',
	SHOW_REVERT_WORKFLOWS_BUTTON: 'revert-workflows-button',
	SHOW_TUTORIAL_VIDEOS: 'show-tutorial-videos',
	IS_RICH_TEXT_SUPPORT_ON: 'rich-text-enabled',
	ALLOW_INSTALLABLES: 'allow-installables',
	ALLOW_CONFIGURATIONS: 'allow-configurations',
	SCHEDULED_TRIGGER_ENABLED: 'scheduled-trigger-enabled',
	ALLOW_PROCESSES: 'allow-processes',
	ALLOW_STUDIO_MODE_SWITCH: 'studio-mode-enabled',
	IS_AI_ENABLED: 'is-ai-enabled',
	IS_LOOM_ON: 'is-loom-enabled',
	ONBOARDING_ENABLED: 'onboarding-enabled',
	IS_IN_APP_HELP_ENABLED: 'is-in-app-help-enabled',
	NOTIFICATIONS_ENABLED: 'notifications-enabled',
	ALLOW_TEST_FEATURE: 'allow-test-feature',
	BUILDER_ONBOARDING_ENABLED: 'builder-onboarding-enabled',
	PLACEMENT_MODE_ENABLED: 'placement-mode-enabled',
	CHANGE_SAMPLE_THROUGH_EXTENSION: 'change-sample-through-extension',
	CASCADE_DROPDOWN_ENABLED: 'cascade-dropdown-enabled',
	INSPIRATION_CENTER_ENABLED: 'inspiration-center-enabled',
	PORTAL_CREATION_ENABLED: 'portal-creation-enabled',
	ANALYTICS_FEATURE_ENABLED: 'analytics-feature-enabled',
	CAN_LOCK_SHARE: 'locked-share-permission-enabled',
	AI_AUTOFILL_ENABLED: 'ai-autofill-enabled',
	DEV_ACCESS_ENABLED: 'dev-access-enabled',
	SLACK_COMMAND_ENABLED: 'slack-slash-commands',
	AI_CODE_GENERATOR_ENABLED: 'ai-code-generator-enabled',
	SIDEBAR_CONTEXTS_ENABLED: 'sidebar-contexts-enabled',
	NARROW_BRANCHES_LAYOUT_ENABLED: 'narrow-branches-layout-enabled',
	ISSUES_MANAGEMENT_ENABLED: 'issues-management-feature-enabled',
	BUILDER_UNDER_MAINTENANCE: 'builder-under-maintenance',
	GETTING_STARTED_SETTINGS: 'getting-started-settings',
	PORTAL_AUTH_ENABLED: 'portal-auth-enabled',
	CUSTOM_DOMAINS_ENABLED: 'custom-domains-enabled',
	ACC_EMAIL_DOMAINS_ENABLED: 'account-email-domains-enabled',
	CANDU_ENABLED: 'candu-enabled',
	INTERFACE_FOCUSED_LAYOUT_MODE_ENABLED: 'interface-focused-layout-mode-enabled',
	SHOW_BILLING_USAGE: 'is-billing-usage-enabled',
});

const FeatureToggleService = {
	setOnInit: applyFn(service.setOnInit),
	getAllFlags: applyFn(service.getAllFlags),
	clearUser: applyFn(service.clearUser),
	buildFtsUserObject: applyFn(service.buildFtsUserObject),
	buildFtsAnonObject: applyFn(service.buildFtsAnonObject),
	initializeUser: applyFn(service.initializeUser),
};

export default FeatureToggleService;
